import React from 'react';
import { useIntl } from 'react-intl';
import { Icon } from '@plone/volto/components';
import deleteSVG from '@plone/volto/icons/delete.svg';

import { messages } from './schema';

interface TemaTituloProps {
  title: string;
  slot: number;
  onRemove: (slot: number) => void;
}

/**
 * Cabeçalho do fieldset do tema com a lixeira, no mesmo desenho da lixeira
 * dos cards do `ObjectListWidget`.
 *
 * Entra no lugar do `title` do fieldset (o `InlineForm` desenha o que vier
 * ali). O clique para no botão: sem o `stopPropagation`, ele também abriria
 * ou fecharia o acordeão.
 */
const TemaTitulo = ({ title, slot, onRemove }: TemaTituloProps) => {
  const intl = useIntl();
  return (
    <>
      {title}
      <button
        type="button"
        className="mpf-onde-atua-tema-remove"
        aria-label={intl.formatMessage(messages.removeTema, { slot })}
        title={intl.formatMessage(messages.removeTema, { slot })}
        onClick={(event) => {
          event.stopPropagation();
          onRemove(slot);
        }}
      >
        <Icon name={deleteSVG} size="20px" color="#e40166" />
      </button>
    </>
  );
};

export default TemaTitulo;
